// assets
import {
    IconPlug,
    Icon24Hours,
    IconClockRecord,
    IconAntenna,
    IconChartHistogram,
    IconUsers,
    IconStatusChange,
    IconHeartRateMonitor,
    IconCloudDownload,
    IconRouter,
    IconBellRingingFilled,
    IconAlarm,
    IconTool,
    IconAccessible,
    IconNotification
} from '@tabler/icons-react';

// constant
const icons = {
    IconPlug,
    Icon24Hours,
    IconClockRecord,
    IconAntenna,
    IconChartHistogram,
    IconUsers,
    IconStatusChange,
    IconHeartRateMonitor,
    IconCloudDownload,
    IconRouter,
    IconBellRingingFilled,
    IconAlarm,
    IconTool,
    IconAccessible,
    IconNotification
};

// ==============================|| REALTIME MENU ITEMS ||============================== //

const settings = {
    id: 'setting',
    title: 'Settings  [ ADMIN ONLY ]',
    type: 'group',
    children: [
        {
            id: 'setting-general',
            title: 'General',
            type: 'collapse',
            icon: icons.IconStatusChange,
            children: [
                {
                    id: 'general-default',
                    title: 'Default',
                    type: 'item',
                    url: '/settings/default/defaultSetting',
                    breadcrumbs: false
                },
                {
                    id: 'setting-data-gateway',
                    title: 'Data Gateway',
                    type: 'item',
                    url: '/settings/datatoserver/gateway',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'setting-iiot-gatway',
            title: 'IIOT Gateway',
            type: 'collapse',
            icon: icons.IconPlug,
            permissions: 'isIiotGateway',
            children: [
                {
                    id: 'setting-iiot-gateway-devices',
                    title: 'Gateway',
                    type: 'item',
                    url: '/settings/modbus/gateway',
                    icon: icons.IconRouter,
                    breadcrumbs: false
                },
                {
                    id: 'setting-connection',
                    title: 'Connection',
                    type: 'item',
                    url: '/settings/modbus/devices',
                    icon: icons.IconPlug,
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'setting-dataReceiver',
            title: 'Data Receiver',
            type: 'collapse',
            icon: icons.IconCloudDownload,
            permissions: ['isHttps', 'isMqtts'], // Multiple permissions
            children: [
                {
                    id: 'setting-dataReceiver-requestMapping',
                    title: 'Request Mapping',
                    permissions: 'isRawData',
                    type: 'item',
                    url: '/settings/dataReceiver/requests',
                    breadcrumbs: false
                },
                {
                    id: 'setting-dataReceiver-convertedData-requestMapping',
                    title: 'Converted Data Map',
                    permissions: 'isPreComputedData',
                    type: 'item',
                    url: '/settings/dataReceiver/convertedDataRequests',
                    breadcrumbs: false
                },
                {
                    id: 'setting-dataReceiver-guide',
                    title: 'Configuration Guide',
                    type: 'collapse',
                    permissions: ['isHttps', 'isMqtts'], // Multiple permissions
                    children: [
                        {
                            id: 'setting-dataReceiver-httpServer-configuration',
                            title: 'HTTP',
                            type: 'item',
                            permissions: 'isHttps',
                            url: '/settings/dataReceiver/httpserver',
                            breadcrumbs: false
                        },
                        {
                            id: 'setting-dataReceiver-mqtt-configuration',
                            title: 'MQTT',
                            permissions: 'isMqtts',
                            type: 'item',
                            url: '/settings/dataReceiver/mqttserver',
                            breadcrumbs: false
                        }
                    ]
                }
            ]
        },
        {
            id: 'setting-realtime',
            title: 'Realtime',
            type: 'item',
            url: '/settings/realtime/screenconfig',
            icon: icons.Icon24Hours,
            breadcrumbs: false
        },
        {
            id: 'setting-scadaScreens',
            title: 'Screens',
            type: 'item',
            url: '/settings/scada/screenconfig',
            icon: icons.IconHeartRateMonitor,
            breadcrumbs: false
        },
        {
            id: 'setting-pollingInterval',
            title: 'Scheduled Data',
            type: 'collapse',
            icon: icons.IconChartHistogram,
            children: [
                {
                    id: 'historical-addr-config',
                    title: 'Report Configuration',
                    type: 'item',
                    url: '/settings/pollingInterval/config',
                    breadcrumbs: false
                },
                {
                    id: 'historical-chart-config',
                    title: 'Trend Configuration',
                    type: 'item',
                    url: '/settings/pollingInterval/chart-config',
                    breadcrumbs: false
                },
                {
                    id: 'historical-visual-Report-config',
                    title: 'Visual Reports',
                    type: 'item',
                    url: '/settings/pollingInterval/visual-report-config',
                    breadcrumbs: false,
                    chip: {
                        label: 'Beta',
                        color: 'secondary',
                        variant: 'filled',
                        size: 'small'
                    }
                }
            ]
        },
        {
            id: 'setting-trigger',
            title: 'Triggered Data',
            type: 'collapse',
            icon: icons.IconAntenna,
            children: [
                {
                    id: 'trigger-addr-config',
                    title: 'Report Configuration',
                    type: 'item',
                    url: '/settings/trigger/config',
                    breadcrumbs: false
                },
                {
                    id: 'trigger-chart-config',
                    title: 'Trend Configuration',
                    type: 'item',
                    url: '/settings/trigger/chart-config',
                    breadcrumbs: false
                },
                {
                    id: 'trigger-visual-Report-config',
                    title: 'Visual Reports',
                    type: 'item',
                    url: '/settings/trigger/visual-report-config',
                    breadcrumbs: false,
                    chip: {
                        label: 'Beta',
                        color: 'secondary',
                        variant: 'filled',
                        size: 'small'
                    }
                }
            ]
        },
        {
            id: 'setting-alarm',
            title: 'Alarm',
            type: 'item',
            url: '/settings/alarm/alarm-config',
            icon: icons.IconAlarm,
            breadcrumbs: false
        },
        {
            id: 'setting-maintenance',
            title: 'Maintenance',
            type: 'collapse',
            icon: icons.IconTool,
            children: [
                {
                    id: 'maintenance-parts-config',
                    title: 'Parts',
                    type: 'item',
                    url: '/settings/maintenance/parts-config',
                    breadcrumbs: false
                },
                {
                    id: 'maintenance-preventive-config',
                    title: 'Preventive',
                    type: 'item',
                    url: '/settings/maintenance/preventive-config',
                    breadcrumbs: false
                },
                {
                    id: 'maintenance-predictive-config',
                    title: 'Predictive',
                    type: 'item',
                    url: '/settings/maintenance/predictive-config',
                    breadcrumbs: false
                }
            ]
        },

        {
            id: 'notification-provider',
            title: 'Notification Provider',
            type: 'collapse',
            icon: icons.IconNotification,
            children: [
                {
                    id: 'msg91-config',
                    title: 'MSG91',
                    type: 'item',
                    url: '/settings/notificationProvider/msg91',
                    breadcrumbs: false
                },
                {
                    id: 'gamil-config',
                    title: 'Gmail',
                    type: 'item',
                    url: '/settings/notificationProvider/gmail',
                    breadcrumbs: false
                },
                {
                    id: 'groups-config',
                    title: 'Groups',
                    type: 'item',
                    url: '/settings/notificationProvider/groups',
                    breadcrumbs: false
                }
            ]
        },
        // {
        //     id: 'setting-user',
        //     title: 'Users',
        //     type: 'item',
        //     url: '/settings/userManagement/users',
        //     icon: icons.IconUsers,
        //     breadcrumbs: false
        // },
        {
            id: 'setting-access-control',
            title: 'Access Control',
            type: 'collapse',
            icon: icons.IconAccessible,
            children: [
                {
                    id: 'setting-user',
                    title: 'Users',
                    type: 'item',
                    url: '/settings/userManagement/users',
                    breadcrumbs: false
                },
                {
                    id: 'setting-access-control-permission-levels',
                    title: 'Permission Levels',
                    type: 'item',
                    url: '/settings/userManagement/permissionLevels',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default settings;
